// extracted by mini-css-extract-plugin
export default {"card-data-container":"dashboard_card-data-container__feUlD","filters-container":"dashboard_filters-container__lVgwW","right-cell":"dashboard_right-cell__ajMnc"};